export default __webpack_public_path__ + "static/media/e-merkator-push-pt.7088eda8.png";